import { takeLatest, put, call, fork, all, select, delay } from "redux-saga/effects"
import * as actions from "@/AppRedux/actions/admin/rateDetailConfig/rateDetailConfigType"
import * as actionCreation from "@/AppRedux/actions/admin/rateDetailConfig"

import { APIPostRequest } from "@/services/connection"
import { SagaIterator } from "redux-saga"
import { API_HEADERS, API_PMS_URL } from "@/constants/ApiSetting"

import { RootState } from "@/AppRedux/reducers"

function* rateDetailsListRequestProcess(): SagaIterator {
  try {
    const authState = yield select((state: RootState) => state.auth)
    const { propCode } = authState

    const url = `${API_PMS_URL}/admin/rate/list`
    const API_BODY = {
      prop_code: propCode,
    }

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)

    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setRateDetailsListSuccess(response.data.result_data))
      yield delay(200)
      yield put(actionCreation.clearRateDetailsProcess())
    } else {
      const message = response.data?.result_msg || "Failed to get rate details list"
      yield put(actionCreation.setRateDetailsListFailure(message))
      yield delay(200)
      yield put(actionCreation.clearRateDetailsProcess())
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setRateDetailsListFailure(message))
    yield delay(200)
    yield put(actionCreation.clearRateDetailsProcess())
  }
}

function* rateDetailsGetRequestProcess({ payload }: actions.RateDetailsGetRequest): SagaIterator {
  try {
    if (!payload?.rateCode) {
      yield put(actionCreation.setRateDetailsGetFailure("Invalid rate code"))
      return
    }

    const authState = yield select((state: RootState) => state.auth)
    const { propCode } = authState

    const url = `${API_PMS_URL}/admin/rate/get`
    const API_BODY = {
      prop_code: propCode,
      rate_code: payload.rateCode,
    }

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)

    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setRateDetailsGetSuccess(response.data.result_data))
      yield delay(200)
      yield put(actionCreation.clearRateDetailsProcess())
    } else {
      const message = response.data?.result_msg || "Failed to get rate detail"
      yield put(actionCreation.setRateDetailsGetFailure(message))
      yield delay(200)
      yield put(actionCreation.clearRateDetailsProcess())
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setRateDetailsGetFailure(message))
    yield delay(200)
      yield put(actionCreation.clearRateDetailsProcess())
  }
}

function* rateDetailsUpdateRequestProcess({ payload }: actions.RateDetailsUpdateRequest): SagaIterator {
  try {
    const authState = yield select((state: RootState) => state.auth)
    const { propCode } = authState

    const url = `${API_PMS_URL}/admin/rate/update`
    const API_BODY: actions.RateDetailsUpdateRequestPayload = {
      prop_code: propCode,
      ...payload,
    }

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)

    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setRateDetailsUpdateSuccess())
      yield delay(200)
      yield put(actionCreation.clearRateDetailsProcess())
    } else {
      const message = response.data?.result_msg || "Failed to update rate detail"
      yield put(actionCreation.setRateDetailsUpdateFailure(message))
      yield delay(200)
      yield put(actionCreation.clearRateDetailsProcess())
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setRateDetailsUpdateFailure(message))
    yield delay(200)
    yield put(actionCreation.clearRateDetailsProcess())
  }
}

function* rateDetailsSortOrderUpdateRequestProcess({ payload }: actions.RateDetailsUpdateSortOrderRequest): SagaIterator {
  try {
    const authState = yield select((state: RootState) => state.auth)
    const { propCode } = authState

    const url = `${API_PMS_URL}/admin/rate/sort_order/update`
    const API_BODY: actions.RateDetailsUpdateSortOrderRequestPayload = {
      prop_code: propCode,
      items: payload,
    }

    const response = yield call(APIPostRequest, url, API_BODY, API_HEADERS)

    if (response.status === 200 && response.data?.result_code === "0") {
      yield put(actionCreation.setRateDetailsUpdateSortOrderSuccess())
      yield delay(200)
      yield put(actionCreation.clearRateDetailsProcess())
    } else {
      const message = response.data?.result_msg || "Failed to update sort order"
      yield put(actionCreation.setRateDetailsUpdateSortOrderFailure(message))
      yield delay(200)
      yield put(actionCreation.clearRateDetailsProcess())
    }
  } catch (error: any) {
    const message = error?.message || "An unexpected error occurred"
    yield put(actionCreation.setRateDetailsUpdateSortOrderFailure(message))
    yield delay(200)
    yield put(actionCreation.clearRateDetailsProcess())
  }
}

function* rateDetailsListRequest() {
  yield takeLatest(actions.RATE_DETAILS_LIST_REQUEST, rateDetailsListRequestProcess)
}

function* rateDetailsGetRequest() {
  yield takeLatest(actions.RATE_DETAILS_GET_REQUEST, rateDetailsGetRequestProcess)
}

function* rateDetailsUpdateRequest() {
  yield takeLatest(actions.RATE_DETAILS_UPDATE_REQUEST, rateDetailsUpdateRequestProcess)
}

function* rateDetailsSortOrderUpdateRequest() {
  yield takeLatest(actions.RATE_DETAILS_UPDATE_SORT_ORDER_REQUEST, rateDetailsSortOrderUpdateRequestProcess)
}

export default function* rootRateDetailConfigSaga() {
  yield all([
    fork(rateDetailsListRequest),
    fork(rateDetailsGetRequest),
    fork(rateDetailsUpdateRequest),
    fork(rateDetailsSortOrderUpdateRequest),
  ])
}
